import { store } from '@store/store';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { AuthProvider } from './contexts/Auth.tsx';
import './i18n';
import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MediaQueryProvider } from './contexts/MediaQueryContext.tsx';
import { brazeConsentManager } from './services/braze';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Initialize Braze (will wait for consent)
brazeConsentManager.initialize();

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <MediaQueryProvider>
            <App />
          </MediaQueryProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>,
);
